module.exports = __webpack_public_path__ + "img/trafficlight_on.5024d3cc.png";